import {
  MockMap,
} from '@ama-sdk/core';
import {
  checkinPNROW1Journey1ADTRegulatoryMissing,
} from './checkin-pnr-ow-1-journey-1-adt-regulatory-missing/checkin-pnr-ow-1-journey-1-adt-regulatory-missing.mock';
import {
  checkinPNROW1Journey2ADTUSRegMissing,
} from './checkin-pnr-ow-1-journey-2-adt-US-reg-missing/checkin-pnr-ow-1-journey-2-adt-US-reg-missing.mock';
import {
  deeplink1Journey1ADTBP,
} from './deeplink-1Journey-1ADTBP.mock';
import {
  deeplinkMultiFlightsMultiPaxBP,
} from './deeplink-multi-flights-multi-pax-BP.mock';
import {
  fullCheckin,
  fullCheckinWithBags,
  fullCheckinWithBagsHPBTFailure,
} from './default-mock';
import {
  demo,
} from './demo/demo-mock';
import {
  ow1Journey2AdtPartialCheckinPartialPayment,
} from './one-way-2adt-partial-checkin-partial-payment-mocks';
import {
  ow1Journey3AdtBpEmailSmsPassbookRetrieve,
} from './one-way-3adt-pax-bp-email-sms-passbook-mock';
import {
  ow1Journey3AdtPaxSelectionContactRetrieve,
} from './one-way-3adt-pax-selection-contact-mock';
import {
  ow1Journey1AdtUpdateContact,
} from './ow-1adt-contact-details-phone-countrycode-mock';
import {
  ow1Journey1AdtChargeableSeats,
} from './ow-1Journey-1-adt-chargeable-seats-mocks';
import {
  ow1Journey1AdtUpdateSeat,
} from './ow-1Journey-1-adt-update-seat-mocks';
import {
  ow1Journey1Adt1Chd1InfMultiBpEmailRetrieve,
} from './ow-1journey-1Adt-1Chd-1Inf-MultiBpEmail-Retrieve-mock';
import {
  ow1JourneyAddCheckedInPaxFromAnotherBooking,
} from './ow-1journey-1Adt-Add-CheckedIn-Pax-From-Another-Booking-mock';
import {
  ow1JourneyAddInEligiblePaxFromAnotherBooking,
} from './ow-1Journey-1Adt-Add-InEligible-Pax-From-Another-Booking-mock';
import {
  ow1Journey1AdtAddBaggageFromATPCO,
} from './ow-1Journey-1Adt-Atpco-chargableBaggage-mock';
import {
  ow1Journey1AdtBaggageAllowanceOnlyWeight,
} from './ow-1Journey-1Adt-Baggage-Allowance-Only-Weights.mock';
import {
  ow1Journey1AdtBaggageAllowanceRetrieve,
} from './ow-1Journey-1Adt-Baggage-Allowance-Retrieve-mock';
import {
  ow1Journey1AdtBaggagePage,
} from './ow-1Journey-1Adt-Baggage-Page-mock';
import {
  ow1Journey1AdtCancelCheckIn,
} from './ow-1Journey-1Adt-Cancel-checkin-mock';
import {
  ow1Journey1AdtCancelledFlightMock,
} from './ow-1Journey-1Adt-Cancelled-Flight-mock';
import {
  ow1Journey1AdtChargeableSeatsbagsandservices,
} from './ow-1journey-1adt-chargeable-seats-bags-services.mock';
import {
  ow1Journey1AdtChargeableBaggagesCheckoutPayment,
  ow1Journey1AdtChargeableBaggagesRetrieve,
} from './ow-1Journey-1Adt-ChargeableBaggages-Retrieve-mock';
import {
  ow1Journey1AdtFFBoardingPassRetrieve,
} from './ow-1Journey-1Adt-FF-BoardingPass-Retrieve-mock';
import {
  ow1Journey1AdtFFRetrieve,
} from './ow-1Journey-1Adt-FF-Retrieve-mock';
import {
  ow1Journey1AdtFFTierDetailsRetrieve,
} from './ow-1Journey-1Adt-FF-Tier-Details-Retrieve-mock';
import {
  ow1Journey1AdtFlightAhead,
} from './ow-1Journey-1Adt-FlightAhead-mock';
import {
  ow1Journey1AdtFlightDelayed,
} from './ow-1Journey-1Adt-FlightDelayed-mock.';
import {
  ow1Journey1AdtManageYourBooking,
} from './ow-1Journey-1Adt-ManageYourBooking-mock';
import {
  ow1Journey1AdtMissingExitDateRegulatory,
} from './ow-1Journey-1Adt-MissingExitDate-mock';
import {
  ow1Journey1AdtMissingRegulatory,
} from './ow-1Journey-1Adt-MissingRegulatory-mock';
import {
  ow1Journey1AdtExitRowRetrieve,
} from './ow-1Journey-1Adt-Retrieve-ExitRow-mock';
import {
  ow1Journey1AdtRetrieveFixedDate,
} from './ow-1Journey-1Adt-Retrieve-fixed-date-mock';
import {
  ow1Journey1AdtRetrieveIterneraryDetails,
} from './ow-1Journey-1Adt-Retrieve-IterneraryDetails-mock';
import {
  ow1Journey1AdtRetrieve,
} from './ow-1Journey-1Adt-Retrieve-mock';
import {
  ow1Journey1AdtStoredExitDateRegulatory,
} from './ow-1Journey-1Adt-StoredExitDate-mock';
import {
  ow1Journey1AdtWaitlistRetrieve,
} from './ow-1Journey-1Adt-Waitlist-Retrieve-mock';
import {
  ow1Journey1Adt1Chd1InfIndividualCheckin,
} from './ow-1Journey-1Adt1Chd1Inf-Individual-Checkin-mock';
import {
  ow1Journey1Adt1Chd1InfRetrieve,
} from './ow-1Journey-1Adt1Chd1Inf-Retrieve-mock';
import {
  ow1Journey1Adt1Chd1InfMultiPaxsRetrieve,
} from './ow-1Journey-1Adt1Chd1InfMultiPaxs-Retrieve-mock';
import {
  ow1Journey2AdtConnectionFlightsRetrieve,
} from './ow-1Journey-2-adt-connection-flights-mock';
import {
  ow1Journey2AdtFFBoardingPassRetrieve,
} from './ow-1journey-2-Adt-FQTV-mocks';
import {
  ow1journey2Adt1Chd1InfRetrive,
} from './ow-1journey-2Adt-1Chd-1Inf-retrive-mock';
import {
  ow1Journey2Adt1ChdTicketingIssue,
} from './ow-1Journey-2Adt-1Chd-TicketIssue-mock';
import {
  ow1journey2AdtInhibitedbpwithblindservices,
} from './ow-1journey-2Adt-Inhibited-Boarding-Pass.mock';
import {
  ow1Journey2AdtMissingRegAddBagPayContacts,
} from './ow-1journey-2Adt-MissingRegulatory-AddBag-Pay-Contacts/ow-1journey-2Flts-2Adt-MissingRegulatory-AddBag-Pay-Contacts-mocks';
import {
  ow1Journey1AdtThroughPricing,
} from './ow-1journey-2adt-through-pricing-mock';
import {
  ow1journey2AdtUnselectedPassengerManageCheckedInPax,
} from './ow-1journey-2adt-unselected-passenger-manage-checkedin-pax.mock';
import {
  ow1journey2AdtUnselectedPassengerSeat,
} from './ow-1journey-2adt-unselected-passenger-seat.mock';
import {
  ow1Journey2AdtUpdateSeat,
} from './ow-1Journey-2adt-update-seat-mocks';
import {
  ow1Journey2Adt1Chd1InfMultiPaxsMissingBpRetrieve,
} from './ow-1journey-2Adt1Chd1InfMultiPaxs-MissingBp-Retrieve-mocks';
import {
  ow1Journey2Flights1AdtPartialAcceptance,
} from './ow-1journey-2flts-1adt-partial-acceptance/ow-1Journey-2flts-1adt-partial-acceptance-mock';
import {
  ow1Journey3AdtChargeableSeatsUnpaidPayment,
} from './ow-1Journey-3-adt-chargeable-seats-unpaid-payment-mocks';
import {
  ow1Journey3Adt1ChdPartialCheckin,
} from './ow-1journey-3Adt-1Chd-Partial-Checkin-mocks';
import {
  ow1Journey3AdtDeallocationOfChargeableSeatsAndBags,
} from './ow-1journey-3adt-deallocation-of-chargeable-seats-mock';
import {
  ow1JourneyFirstNameFilteringGroupPax,
} from './ow-1Journey-FirstName-Filtering-Group-Pax-mock';
import {
  ow1JourneyAddPaxFromAnotherBooking,
} from './ow-1Journey-multipax-Add-Pax-From-Another-Booking-mock';
import {
  additionalNoteSection,
} from './ow-2adt-bp-addtional-note-mock';
import {
  owMultiLeg1Journey1AdtExitRowSeatEligbilityFailure,
} from './ow-multileg-1Journey-1-Adt-exit-row-eligibility-failure-mocks';
import {
  owMultiLeg1Journey1AdtChargeableAndFreeSeats,
} from './ow-multileg-1Journey-1-Adt-seats-mocks';
import {
  owMultileg2AdtSeatDetailsInOverviewRetrieve,
} from './ow-multileg-2adt-seat-details-in-overview-retrieve-mock';
import {
  owMultileg2AdtSeatItineraryDetailsBoardingPassRetrieve,
} from './ow-multileg-2adt-seat-itinerary-details-boardingPass-retrieve-mock';
import {
  rt1Journey1AdtRetrieve,
} from './rt-1Journey-1Adt-Retrieve-mock';
import {
  rt1Journey1Adt1Chd1InfIndividualCheckin,
} from './rt-1Journey-1Adt1Chd1Inf-Checkin-mock';
import {
  rt1Journey1Adt1Chd1InfRetrieve,
} from './rt-1Journey-1Adt1Chd1Inf-Retrieve-mock';
import {
  rt2Journey1Adt1Chd1InfIndividualCheckin,
} from './rt-2Journey-1Adt1Chd1Inf-Checkin-mock';
import {
  rt2Journeys1AdtRetrieve,
} from './rt-2Journeys-1Adt-Retrieve-mock';
import {
  rt2Journeys1Adt1Chd1InfRetrieve,
} from './rt-2Journeys-1Adt1Chd1Inf-Retrieve-mock';
import {
  rt3Journeys1Adt1Chd1InfCheckin,
} from './rt-3Journeys-1Adt1Chd1Inf-Checkin-mock';
import {
  tsa,
} from './tsa-mock';

/**
 * AdapterMap contains the scenario (key) and the adapter associated to each scenario.
 */
export const mockMaps: {[scenario: string]: MockMap;} = {
  deeplink1Journey1ADTBP,
  deeplinkMultiFlightsMultiPaxBP,
  demo,
  ow1Journey2AdtFFBoardingPassRetrieve,
  fullCheckin,
  fullCheckinWithBags,
  fullCheckinWithBagsHPBTFailure,
  ow1Journey1AdtRetrieve,
  ow1Journey1AdtRetrieveIterneraryDetails,
  ow1Journey1AdtRetrieveFixedDate,
  ow1Journey1AdtFlightAhead,
  ow1Journey1Adt1Chd1InfMultiPaxsRetrieve,
  ow1Journey1Adt1Chd1InfIndividualCheckin,
  ow1Journey2AdtConnectionFlightsRetrieve,
  ow1Journey2Adt1Chd1InfMultiPaxsMissingBpRetrieve,
  ow1Journey1Adt1Chd1InfRetrieve,
  ow1Journey1AdtFFRetrieve,
  ow1Journey1AdtChargeableBaggagesRetrieve,
  ow1Journey1AdtChargeableBaggagesCheckoutPayment,
  ow1Journey1AdtChargeableSeats,
  owMultiLeg1Journey1AdtChargeableAndFreeSeats,
  owMultiLeg1Journey1AdtExitRowSeatEligbilityFailure,
  ow1Journey1AdtBaggageAllowanceRetrieve,
  ow1Journey1AdtFFBoardingPassRetrieve,
  ow1Journey1AdtChargeableSeatsbagsandservices,
  ow1Journey2Flights1AdtPartialAcceptance,
  ow1JourneyFirstNameFilteringGroupPax,
  ow1Journey2Adt1ChdTicketingIssue,
  rt1Journey1Adt1Chd1InfIndividualCheckin,
  ow1Journey2AdtMissingRegAddBagPayContacts,
  ow1Journey1AdtBaggagePage,
  ow1Journey3Adt1ChdPartialCheckin,
  ow1Journey1AdtManageYourBooking,
  ow1Journey1AdtMissingRegulatory,
  ow1Journey1AdtMissingExitDateRegulatory,
  ow1Journey1AdtStoredExitDateRegulatory,
  ow1Journey1AdtWaitlistRetrieve,
  tsa,
  ow1journey2Adt1Chd1InfRetrive,
  ow1journey2AdtUnselectedPassengerSeat,
  rt1Journey1AdtRetrieve,
  rt1Journey1Adt1Chd1InfRetrieve,
  rt2Journeys1AdtRetrieve,
  rt2Journeys1Adt1Chd1InfRetrieve,
  ow1Journey2AdtPartialCheckinPartialPayment,
  rt3Journeys1Adt1Chd1InfCheckin,
  rt2Journey1Adt1Chd1InfIndividualCheckin,
  checkinPNROW1Journey1ADTRegulatoryMissing,
  checkinPNROW1Journey2ADTUSRegMissing,
  ow1Journey1Adt1Chd1InfMultiBpEmailRetrieve,
  additionalNoteSection,
  ow1Journey1AdtAddBaggageFromATPCO,
  ow1Journey1AdtCancelCheckIn,
  ow1JourneyAddPaxFromAnotherBooking,
  ow1JourneyAddCheckedInPaxFromAnotherBooking,
  ow1Journey1AdtUpdateSeat,
  ow1Journey1AdtFFTierDetailsRetrieve,
  ow1Journey3AdtChargeableSeatsUnpaidPayment,
  ow1Journey3AdtDeallocationOfChargeableSeatsAndBags,
  owMultileg2AdtSeatDetailsInOverviewRetrieve,
  ow1Journey3AdtBpEmailSmsPassbookRetrieve,
  ow1Journey3AdtPaxSelectionContactRetrieve,
  ow1JourneyAddInEligiblePaxFromAnotherBooking,
  owMultileg2AdtSeatItineraryDetailsBoardingPassRetrieve,
  ow1Journey1AdtExitRowRetrieve,
  ow1Journey1AdtFlightDelayed,
  ow1Journey2AdtUpdateSeat,
  ow1journey2AdtUnselectedPassengerManageCheckedInPax,
  ow1Journey1AdtCancelledFlightMock,
  ow1Journey1AdtUpdateContact,
  ow1Journey1AdtBaggageAllowanceOnlyWeight,
  ow1Journey1AdtThroughPricing,
  ow1journey2AdtInhibitedbpwithblindservices
};
